// ─── Suppression de compte SELF-SERVICE (Core) ────────────────────
// Exigence Google Play / Apple (2023) : un compte qui peut s'inscrire doit
// pouvoir se supprimer lui-même, dans l'app.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export const demanderSuppressionCompte = () =>
  httpsCallable(functions, 'demanderSuppressionCompte')({}).then(r => r.data);
